import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchVisionOle() {
  try {
    const { data } = yield call(api.get, {
      route: `SocialDV/GetDetailSociaDVByEquipmentId/28`,
    });
    console.log(data);
    const visionOLEData = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setVisionOle({ visionOLEData }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_VISION_OLE, fetchVisionOle)]);
}
